import { useState } from 'react';

import { Breadcrumb } from 'components/Breadcrumb';
import { PageHeader } from 'components/PageHeader';
import { PageHeading } from 'components/PageHeading';
import { TimeFrame } from 'components/time-frame/time-frame';
import { TimeFrameState } from 'components/time-frame/types';
import { useTranslation } from 'contexts/translation-context';
import { useSustainabilityReporting } from '../models';
import { SustainabilityAveragesGrid, SustainabilityTotalsGrid } from '../components/SustainabilityMetricCard';

export const SustainabilityReportPage = () => {
  const { i18n } = useTranslation();
  const [timeFrame, setTimeFrame] = useState<null | TimeFrameState>(null);
  const { data } = useSustainabilityReporting(
    timeFrame
      ? {
          startDate: timeFrame.startDate,
          endDate: timeFrame.endDate,
        }
      : null,
  );

  const results = data ?? {
    totalOrders: 0,
    totalDistance: 0,
    totalWeight: 0,
    totalEmissions: 0,
  };

  const title = i18n('customerPortal.sustainability.sustainability');
  return (
    <>
      <PageHeader title={title} />

      <PageHeading leftSide={<Breadcrumb currentItem={title} />} />

      <div className="flex justify-end items-end px-8">
        <div>
          <TimeFrame onChange={setTimeFrame} />
        </div>
      </div>

      <div className="p-8">
        <div className="heading-three mb-4">Totaal</div>

        <SustainabilityTotalsGrid results={results} className="mb-8" />

        <div className="heading-three mb-4">Gemiddelde per order</div>

        <SustainabilityAveragesGrid results={results} />
      </div>
    </>
  );
};
